<template>
  <v-app id="app">
    <Topbar />
    <Default />
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>
<style lang="scss">
@import "utils/common";
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#app {
  position: relative;
  display: flex;
  background: #ffffff;
  @include common_font;
}
</style>
